export { default as slide1 } from "./slide-01.mdx";
export { default as slide2 } from "./slide-02.mdx";
export { default as slide3 } from "./slide-03.mdx";
export { default as slide4 } from "./slide-04.mdx";
export { default as slide5 } from "./slide-05.mdx";
export { default as slide6 } from "./slide-06.mdx";
export { default as slide7 } from "./slide-07.mdx";
export { default as slide8 } from "./slide-08.mdx";
export { default as slide9 } from "./slide-09.mdx";
export { default as slide10 } from "./slide-10.mdx";
export { default as slide11 } from "./slide-11.mdx";
